/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentDocumentFormNamePicker: "shipment-document-form-name-picker",
  shipmentDocumentFormNameSearch: "shipment-document-form-name-search",
  shipmentDocumentFormIncludeForInvoicing: "shipment-document-form-include-for-invoicing",
  shipmentDocumentFormIncludeInRatecon: "shipment-document-form-include-in-ratecon",
  shipmentDocumentFormIncludeOnOrderCompletion: "shipment-document-form-include-on-order-completion",
  shipmentDocumentFormAssociatedLocation: "shipment-document-form-associated-location",
  shipmentDocumentFormAssociatedLocationOption: "shipment-document-form-associated-location-option",
  shipmentDocumentFormVisibility: "shipment-document-form-visibility",
  shipmentDocumentFormVisibilityOption: "shipment-document-form-visibility-option",
} as const;
